module.exports = __webpack_public_path__ + "static/img/wheel.a7903d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/wheel.png
// module id = BcIx
// module chunks = 1